import styled, { css, Interpolation } from 'styled-components'

export interface TiptapWrapperUiProps {
  styles?: Interpolation<object>
}

export const TiptapWrapperUi = styled.div<TiptapWrapperUiProps>`
  .tippy-box {
    max-width: none !important;
    min-width: 258px
  }
  ${p =>
    p.styles &&
    css`
    ${p.styles}
  `}
`
